import { IPixabayImageSearchOptions } from '../../../models/Pixabay';

export const DefaultHighResHorizontalPixabayImageSearchOptions: IPixabayImageSearchOptions = {
	min_width: 1200,
	orientation: 'horizontal',
};
